import { HttpErrorResponse } from "@angular/common/http";
import { LearnerResourcesDto, UpdateLearnerResourcesDto } from "src/app/_models/LearnerResources";

export interface LearnerResourcesState {
  learnerResources: LearnerResourcesDto[];
  learnerResourcesLoader: boolean;
  learnerResourcesError: HttpErrorResponse;

  moduleTypes: string[];
  moduleTypesLoader: boolean;
  moduleTypesError: HttpErrorResponse;

  updateLearnerResources: UpdateLearnerResourcesDto;
  updateLearnerResourcesResult: boolean;
  updateLearnerResourcesLoader: boolean;
  updateLearnerResourcesError: HttpErrorResponse;
}

export const initialLearnerResourceState: LearnerResourcesState = {
  learnerResources: null,
  learnerResourcesLoader: false,
  learnerResourcesError: null,

  moduleTypes: null,
  moduleTypesLoader: false,
  moduleTypesError: null,

  updateLearnerResources: null,
  updateLearnerResourcesResult: null,
  updateLearnerResourcesLoader: false,
  updateLearnerResourcesError: null,
}